import { z } from 'zod'
import { AbTest } from 'src/graphql.generated'

export const EMPTY_VALUE = '@@EMPTY_VALUE@@'

export const getABTestValidationSchema = (abTests?: Array<Pick<AbTest, 'name' | 'variants'>> | null) => {
  const abTestValidationSchema = Object.fromEntries(
    (abTests ?? []).map((test) => {
      const variantNames = test.variants.map((variant) => variant.name)

      return [
        test.name,
        z.union([
          z.literal(EMPTY_VALUE).transform(() => null),
          z
            .string()
            .min(1)
            .refine((value) => variantNames.includes(value), {
              message: 'Invalid AB test group name',
            }),
        ]),
      ]
    })
  )

  return z.object({
    patientABTestsByName: z.object(abTestValidationSchema),
  })
}
